export default {
  listState: state => state.list,
  listOptionsState: state => state.listOptions,
  listByNetworkState: state => state.listByNetwork,
  listByNetworkOptionsState: state => state.listByNetworkOptions,
  listTypeState: state => state.listType,
  listTypeOptionsState: state => state.listTypeOptions,
  listTypeByNetworkState: state => state.listTypeByNetwork,
  listTypeByNetworkOptionsState: state => state.listTypeByNetworkOptions
}
